export default function ({ store, redirect }) {
  return redirect('/dashboard/pageindevelop')
}
